import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
	headerCard: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: 18,
		boxShadow: "0 14px 34px rgba(15, 23, 42, 0.1)",
		padding: theme.spacing(1.5, 2),
		marginBottom: theme.spacing(1.5),
		border: "1px solid rgba(15, 23, 42, 0.06)",
	},
	headerRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		flexWrap: "wrap",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
			alignItems: "flex-start",
		},
	},
	title: {
		fontWeight: 700,
		color: theme.palette.text.primary,
	},
	subtitle: {
		marginTop: theme.spacing(0.5),
		color: theme.palette.text.secondary,
	},
	actions: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		flexWrap: "wrap",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			justifyContent: "flex-start",
			flexDirection: "column",
			alignItems: "stretch",
		},
	},
	extra: {
		marginTop: theme.spacing(1.5),
	},
}));

const MainHeader = ({ title, subtitle, actions, children }) => {
	const classes = useStyles();

	return (
		<div className={classes.headerCard}>
			<div className={classes.headerRow}>
				<div>
					<Typography variant="h5" className={classes.title}>
						{title}
					</Typography>
					{subtitle ? (
						<Typography variant="body2" className={classes.subtitle}>
							{subtitle}
						</Typography>
					) : null}
				</div>
				{actions ? <div className={classes.actions}>{actions}</div> : null}
			</div>
			{children ? <div className={classes.extra}>{children}</div> : null}
		</div>
	);
};

export default MainHeader;
